import React from 'react';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';

function Privacy() {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={3}>Privacy Policy</Typography>
      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
          <Typography variant="caption" color="text.secondary" display="block" mb={3}>Last update: January 2025</Typography>
          
          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>1. Data Controller</Typography>
          <Typography paragraph>
            Digitoo Group S.r.l., with registered office at Via Confienza 10, 10121 Turin (TO), Italy, VAT number 12705900012 (hereinafter "Digitoo").
          </Typography>
          <Typography paragraph>Contact: info@digitoogroup.com</Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>2. Scope of Application</Typography>
          <Typography paragraph>
            This Privacy Policy applies to Digitoo's proprietary conversion tracking and attribution platform (the "Platform"), accessible exclusively to Digitoo and previously authorized and contracted affiliates.
          </Typography>
          <Typography paragraph>
            Autonomous registration or access by clients, advertisers, or the general public is not permitted.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>3. Types of Data Processed</Typography>
          <Typography paragraph>Within the scope of the Platform's operation, Digitoo processes:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography>Technical browsing data (IP address, user agent, timestamp)</Typography></li>
            <li><Typography>Technical tracking identifiers (click ID, conversion ID, campaign ID)</Typography></li>
            <li><Typography>Data related to conversion events and leads</Typography></li>
            <li><Typography>Identification and contact data of affiliates</Typography></li>
          </Box>
          <Typography paragraph>
            Data relating to end users is not visible to affiliates but exclusively to Digitoo as Platform administrator.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>4. Purpose of Processing</Typography>
          <Typography paragraph>Data is processed to:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography>Enable the Platform's operation</Typography></li>
            <li><Typography>Attribute, validate, and measure conversions and leads</Typography></li>
            <li><Typography>Prevent fraud and unauthorized use</Typography></li>
            <li><Typography>Fulfill contractual and legal obligations</Typography></li>
          </Box>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>5. Legal Basis</Typography>
          <Typography paragraph>Processing is based on:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography>Performance of a contract (Art. 6.1.b GDPR)</Typography></li>
            <li><Typography>Legal obligations (Art. 6.1.c GDPR)</Typography></li>
            <li><Typography>Legitimate interest of the Controller in the security and integrity of the Platform (Art. 6.1.f GDPR)</Typography></li>
          </Box>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>6. Methods and Security</Typography>
          <Typography paragraph>
            Processing is carried out using IT tools and adequate technical and organizational measures to ensure data security.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>7. Data Retention</Typography>
          <Typography paragraph>
            Tracking data is retained for a maximum period of 24 months, unless legal obligations require otherwise.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>8. Data Disclosure</Typography>
          <Typography paragraph>
            Data may be disclosed to technical service providers and competent authorities. Data is not disseminated.
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>9. Data Subject Rights</Typography>
          <Typography paragraph>
            Data subjects may exercise the rights provided by the GDPR by writing to the Data Controller. It is possible to lodge a complaint with the Italian Data Protection Authority (Garante per la protezione dei dati personali).
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Privacy;
